import Header from '@/components/partners/Header'
import Footer from '@/components/partners/Footer'
import IntroSection from '@/components/partners/IntroSection'
import ProgramaSection from '@/components/partners/ProgramaSection'
import PorQueEscolherSection from '@/components/partners/PorQueEscolherSection'
import BeneficiosSection from '@/components/partners/BeneficiosSection'
import ComoFuncionaSection from '@/components/partners/ComoFuncionaSection'
import FAQSection from '@/components/partners/FAQSection'
import { Separator } from '@/components/ui/separator'

const Index = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <main className="flex-1">
        <IntroSection />
        <div className="max-w-4xl mx-auto px-6">
          <Separator className="bg-border/40" />
        </div>
        <ProgramaSection />
        <div className="max-w-4xl mx-auto px-6">
          <Separator className="bg-border/40" />
        </div>
        <PorQueEscolherSection />
        <div className="max-w-4xl mx-auto px-6">
          <Separator className="bg-border/40" />
        </div>
        <BeneficiosSection />
        <div className="max-w-4xl mx-auto px-6">
          <Separator className="bg-border/40" />
        </div>
        <ComoFuncionaSection />
        <div className="max-w-4xl mx-auto px-6">
          <Separator className="bg-border/40" />
        </div>
        <FAQSection />
      </main>
      <Footer />
    </div>
  )
}

export default Index
